import {useSuspenseQuery} from '@tanstack/react-query';
import {getInviteConfig} from '@/data/invitation-api';

export const useInviteConfig = (orgId: string) => {
    return useSuspenseQuery({
        queryKey: ['inviteConfig', orgId],
        queryFn: () => getInviteConfig(orgId),
        staleTime: 5 * 60 * 1000,
    });
};
